<template>
  <component :is="layout" v-bind="layoutProps">
    <transition mode="out-in">
      <router-view v-if="serviceAvailable" @layout="handleLayoutUpdate" />
      <service-unavailable v-else />
    </transition>
    <!--
      TODO
      シーズンコンポーネントのファクトリを作成して、そこで時期に応じて
      作成するコンポーネントを変えるようにすれば良さそう。
      -->
    <snow-fall v-if="enableSeasonFeature" />
    <chat-widget />
  </component>
</template>

<script>
import SnowFall from '@/components/season_feature/SnowFall.vue'
import ServiceUnavailable from '@/components/ServiceUnavailable'
import ChatWidget from '@/components/common/ChatWidget.vue'

export default {
  components: { ServiceUnavailable, SnowFall, ChatWidget },
  data() {
    return {
      layout: 'div',
      layoutProps: {},
    }
  },
  computed: {
    serviceAvailable() {
      return this.$store.state.service.available
    },
    enableSeasonFeature() {
      return this.$store.state.preferences.enableSeasonFeature
    },
  },
  watch: {
    serviceAvailable(available) {
      if (!available) {
        this.layout = 'div'
      }
    },
  },
  methods: {
    handleLayoutUpdate(payload) {
      // payload が { layout: ..., props: ... } の形式かチェック
      if (payload && payload.layout) {
        this.layout = payload.layout
        this.layoutProps = payload.props || {}
      } else {
        this.layout = payload
        this.layoutProps = {}
      }
    },
  },
}
</script>

<style lang="scss">
.no-select {
  user-select: none;
}
</style>

<style lang="scss" scoped>
// Router Transition Animation
.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease-in-out;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>
